import cn from 'classnames';
import { ProgressSpinner } from 'primereact/progressspinner';

import { ValueOf } from '@shared/types/common';

import styles from './Spinner.module.scss';

const SpinnerVariants = {
  DEFAULT: 'default',
  FULL_SCREEN_OVERLAY: 'fullScreenOverlay',
  ELEMENT_OVERLAY: 'elementOverlay',
} as const;

interface SpinnerProps {
  variant?: ValueOf<typeof SpinnerVariants>;
  disableBackground?: boolean;
  className?: string;
}

export function Spinner({ variant = SpinnerVariants.DEFAULT, disableBackground, className }: SpinnerProps) {
  if (variant === SpinnerVariants.DEFAULT) {
    return <ProgressSpinner className={styles.spinner} />;
  }

  return (
    <div
      className={cn(styles.overlay, className, {
        [styles.elementOverlay]: variant === SpinnerVariants.ELEMENT_OVERLAY,
        [styles.fullscreenOverlay]: variant === SpinnerVariants.FULL_SCREEN_OVERLAY,
        [styles.noBackground]: disableBackground,
      })}
    >
      <ProgressSpinner className={styles.spinner} />
    </div>
  );
}
